// extracted by mini-css-extract-plugin
export default {"main":"Video_main__QmEyo","container":"Video_container__BpDi2","player":"Video_player__7DX0-","React_player":"Video_React_player__+1Aqd","animation":"Video_animation__J55n-"};